import { render } from "./Tabs.vue?vue&type=template&id=913904f2"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=913904f2&lang=scss"
script.render = render

export default script